import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Building2 } from 'lucide-react';
import { useT } from '../contexts/LanguageContext';

/**
 * Reusable building filter dropdown. Pass `value` (id or 'all') and `onChange`.
 * Optional `buildings` prop reuses an already-fetched list to avoid duplicate API calls.
 */
export default function BuildingFilter({ value = 'all', onChange, buildings: externalBuildings, className = '' }) {
  const [internal, setInternal] = useState([]);
  const buildings = externalBuildings ?? internal;
  const t = useT();
  const allLabel = (() => { const x = t('accounting.allBuildings'); return x === 'accounting.allBuildings' ? 'All buildings' : x; })();

  useEffect(() => {
    if (externalBuildings) return;
    axios.get(`${API}/buildings`, { withCredentials: true })
      .then(r => setInternal(r.data || []))
      .catch(() => setInternal([]));
  }, [externalBuildings]);

  return (
    <div className={`inline-flex items-center gap-2 ${className}`}>
      <Building2 className="w-4 h-4 text-slate-500" />
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid="building-filter-trigger" className="w-[200px] h-9">
          <SelectValue placeholder={allLabel} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all" data-testid="building-filter-all">{allLabel}</SelectItem>
          {buildings.map(b => (
            <SelectItem key={b.id} value={b.id} data-testid={`building-filter-${b.id}`}>{b.name}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
